import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Box, Text } from "@chakra-ui/react";
import { getPages } from "../../../../api/wordpressPages";
import { updateFormConfig } from "../../../../redux/actions/formConfigActions";
const RedirectWordpressBody = ({
  redirectWordpressPage,
  dispatchUpdateFormConfig,
}) => {
  const [pages, setPages] = useState([]);
  const handleOnChange = (e) => {
    e.preventDefault();
    const value = e.target.value;
    console.log("value",value);
    dispatchUpdateFormConfig({ redirectWordpressPage: value });
  };

  const renderPages = () => {
    if (!pages.length) {
      return <option value="">Loading...</option>;
    }
    const mapPages = pages.map((page) => {
      console.log("page---==>",page.link)
      return (
        <option key={page.id} value={page.link}>
          {page.title.rendered}
        </option>
      );
    });
    return mapPages;
  };

  useEffect(() => {
    getPages().then((response) => {
      setPages(response);
    });
  },[]);
  return (
    <Box mt="12px" className="form-config__body">
      <Text fontSize="12px" mb="4px" fontWeight="600" color="#475867">
        Select Wordpress page
      </Text>
      <Box w="598px" h="32px">
        {" "}
        <select
          value={redirectWordpressPage}
          onChange={handleOnChange}
          style={{
            color: "#12344D",
            fontWeight: "600",
            fontSize: "14px",
            minWidth: "581px",
            width: "100%",
            height: "32px",
            border: "1px",
            borderStyle: "solid",
            borderColor: "#CFD7DF",
            borderRadius: "4px",
          }}
        > <option key="01" value="">Select wordpress page</option>
          {renderPages()}
        </select>
      </Box>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    redirectWordpressPage: state.formConfig.redirectWordpressPage,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    dispatchUpdateFormConfig: bindActionCreators(updateFormConfig, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RedirectWordpressBody);
